import { ItemPrerolls } from '@utils';
import { VideoContextType } from './videoContext'


export interface DraperPlayerParentListeners {
    onPlayStart?: () => void
    onPlayStop?: () => void
    onPlayComplete?: () => void
}
  
export interface DraperPlayerProps {
    prerolls: ItemPrerolls
    link?: string
    placement: DraperPlayerPlacement
    parentListeners?: DraperPlayerParentListeners
    videoContext: VideoContextType
    playerIsActive: boolean // active or passive playback (e.g user initiated?)
    enableFullscreen: boolean
}
  
export interface DraperPlayerState {
    playing: boolean
    originalVolume?: number
    hasError: boolean
    defaultVolume?: number
    paused: boolean
}

export const enum DraperPlayerPlacement {
    Superhero,
    Packshot,
    IntermissionHero
}